import styled from 'styled-components';

const Root = styled.div `
  &.tend-ui-drawer-footer {
    padding: 16px 24px;
    border-top: none;
  }
`;

export { Root };
//# sourceMappingURL=styled.js.map
